export const ACCEPT_IMAGES_EXTENSION = 'image/png, image/jpeg, image/gif';
export const ACCEPT_AUDIO_EXTENSION = 'audio/*';
export const LAYOUT_SIDE_PADDING = 64;
export const MAX_LAYOUT_WIDTH = 1280;
export const NEW_DRS_QUERY = 'isNew=true';
export const MAX_FILE_SIZE = 25 * 1024 * 1024; // 25 MB
export const TABLET_SIZE = 1024;
